import * as Models from "../../ts/rlAdmin.models";
import * as Utils from "../../ts/rlAdmin.utils";
import * as Consts from "../../ts/rlAdmin.consts";

import { BaseContractController } from "../_baseDealController";
import { ContractService } from "../../services/contract-service";
import { EntityService } from "../../services/entity-service";
import { ContractSharedDataService } from "../../services/contract-shared-data-service";
import { LocalCacheService } from "../../services/local-cache-service";
import { NotifyService } from "../../services/notify-service";
import { EventService } from "../../services/event-service";
import { AdminService } from "../../services/admin-service";
import { AclService } from "../../services/acl-service";

/*
 * Controller for Contract Summary Page
 */
export class DealSummaryController extends BaseContractController {

    static $inject = ["$scope", "$q", "$window", "contractService", "entityService",
        "contractSharedDataService", "localCacheService", "notifyService", "eventService", "adminService",
        "$interval", "aclService", "$location", "$anchorScroll"];

    contractID: string;                                                     // contract EntityID
    visibility: number;                                                     // visibility level of page
    locked: boolean;
    isValid: boolean;
    currencySymbol: string;
    charTypeName: string;
    listUrl: string;
    canEdit: boolean;
    showAssets: boolean;
    showContacts: boolean;
    showDetails: boolean;
    showDocuments: boolean;
    showRights: boolean;
    showRoyalties: boolean;
    showFinancials: boolean;
    showInventory: boolean;
	showJobs: boolean;

    selectedEntity: (Models.IContractRightDocumentRelationshipPair | Models.IPropertyRightsetDocumentRelationshipPair);
    selectedEntities: (Models.IContractRightDocumentRelationshipPair | Models.IPropertyRightsetDocumentRelationshipPair)[];

    allowableChidrenCharTypesOfTables: number[];
    initialized: boolean;

    constructor($scope: ng.IScope,
        $q: ng.IQService,
        private $window: ng.IWindowService,
        private contractService: ContractService,
        entityService: EntityService,
        sharedData: ContractSharedDataService,
        localStorage: LocalCacheService,
        notifyService: NotifyService,
        private eventService: EventService,
        adminService: AdminService,
        $interval: ng.IIntervalService,
        private aclService: AclService,
        $location: ng.ILocationService,
        $anchorScroll: ng.IAnchorScrollService) {

        super($scope, entityService, sharedData, localStorage, notifyService, adminService, $interval, $q, $location, $anchorScroll);

        this.contractID = "";
        this.visibility = 1;
        this.locked = false;
        this.isValid = false;
        this.charTypeName = "";
        this.listUrl = "~/";
        this.canEdit = false;

        this.showAssets = false;
        this.showContacts = false;
        this.showDetails = false;
        this.showDocuments = false;
        this.showFinancials = false;
        this.showInventory = false;
        this.showRights = false;
        this.showRoyalties = false;
        this.showJobs = false;

        this.selectedEntities = [];

        this.allowableChidrenCharTypesOfTables = [1, 16];   //As more child char types are needed for children of Tables, append to this list
        this.initialized = false;

        $scope.$on(Consts.Events.ViewEntity, (e, data) => {
            if (!_.isEmpty(data)) {
                var previewEntityCharTypeID = Utils.IdBuilder.splitEntityID(data).charTypeID;
                if (previewEntityCharTypeID == Consts.CharTypeIDs.invoice || previewEntityCharTypeID == Consts.CharTypeIDs.inventory) {
                    this.ViewEntity(data);
                }
            }
        });

        $scope.$watch(
            () => this.sharedData.contractStatus != null ? this.sharedData.contractStatus.lockIndicator : 1,
            (newValue, oldValue) => {
                this.locked = newValue > 0;
            });

        $scope.$watch(
            () => {
                if (this.sharedData.contract != null) {
                    return this.sharedData.contract.charDataCollection.charDatas[Consts.TagLabels.Currency];
                } else {
                    return null;
                }
            },
            (newValue) => {
                if (newValue != null && newValue.length > 0) {
                    this.currencySymbol = newValue[0].value;
                } else {
                    this.currencySymbol = "";
                }
            }, true);

        $scope.$watch(() => {
            if (this.contractID == null) {
                return null;
            } else {
                return this.contractID;
            }
        },
            (newValue, oldValue) => {
                if (newValue != null) {
                    this.eventService.on(Consts.Events.WorkflowExecuted + newValue, () => {
                        return this.sharedData.RefreshContract(newValue);
                    });
                }
            });

        this.aclService.loadActivityAcls()
            .then((acls) => {
                this.canEdit = Utils.AclUtil.hasWriteAccess(acls, Consts.Acl.Activities._Site.Mod4);

                this.showAssets = Utils.AclUtil.hasReadAccess(acls, Consts.Acl.Activities._Site._Mod4.Assets);
                this.showContacts = Utils.AclUtil.hasReadAccess(acls, Consts.Acl.Activities._Site._Mod4.Contacts);
                this.showDetails = Utils.AclUtil.hasReadAccess(acls, Consts.Acl.Activities._Site._Mod4.Details);
                this.showDocuments = Utils.AclUtil.hasReadAccess(acls, Consts.Acl.Activities._Site._Mod4.Documents);
                this.showFinancials = Utils.AclUtil.hasReadAccess(acls, Consts.Acl.Activities._Site._Mod4.Accounting);
                this.showInventory = Utils.AclUtil.hasReadAccess(acls, Consts.Acl.Activities._Site._Mod4.Inventory);
                this.showRights = Utils.AclUtil.hasReadAccess(acls, Consts.Acl.Activities._Site._Mod4.Rights);
                this.showRoyalties = Utils.AclUtil.hasReadAccess(acls, Consts.Acl.Activities._Site._Mod4.Royalties);
                this.showJobs = Utils.AclUtil.hasReadAccess(acls, Consts.Acl.Activities._Site._Mod4.Delivery);
            });
    }

    /*
     * Initialize controller
     * @param entityID entityID string of contract
     */
    Init(entityID: string, charTypeName: string, listUrl: string) {
        this.contractID = entityID;
        this.sharedData.RefreshContract(this.contractID);
        this.sharedData.RefreshContractStatus(this.contractID)
            .then(() => {
                this.initialized = true;
            });
        if (!_.isEmpty(charTypeName)) {
            this.charTypeName = charTypeName;
        }
        if (!_.isEmpty(listUrl)) {
            this.listUrl = listUrl;
        }
    }

    /*
     * Refresh all sections of contract summary
     */
    RefreshAll(): ng.IPromise<any> {
        // start progress bar
        this.notifyService.startProgress();
        var promises = [];
        promises.push(this.RefreshValidation());
        promises.push(this.eventService.call(Consts.Events.ContractRefreshAll));

        return this.$q.all(promises)
            .finally(() => {
                this.notifyService.endProgress();
            });
    }

    RefreshValidation(): ng.IPromise<any[]> {
        return this.eventService.call(Consts.Events.ValidateEntity);
    }

    Delete() {
        if (this.$window.confirm("Are you sure you want to delete this " + this.charTypeName + "?") && this.$window.confirm("Are you REALLY SURE you want to delete this " + this.charTypeName + "?")) {
            this.notifyService.startProgress();
            this.contractService.deleteContract(this.contractID)
                .then(() => {
                    this.$window.location.assign(this.listUrl);
                },
                () => {
                    this.notifyService.notifyError("Error Deleting " + this.charTypeName);
                })
                .finally(() => {
                    this.notifyService.endProgress();
                });
        } else {
            this.$scope.$broadcast(Consts.Events.NotifyDone);
        }
    }

    CopySuccessful(newEntityID: string) {
        //copy succeeded, navigate user to new entity
        this.$window.location.assign("/Go/" + newEntityID);
    }
}
